import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import 'material-symbols';
import { ToastContainer } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/style/main.css';
import GlobalStyle from './globalStyles';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { install } from 'resize-observer';
import './helpers/sentry';
import { HistoryRouter } from './routes/HistoryRouter';
import { ErrorModalProvider } from './components/error-modal/ErrorModalContext';
import { queryClient } from './queryClient';
import { composeProviders } from './utils/composeProviders';

// IOS old safari fix ** below v13 **
// eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
if (!window.ResizeObserver) install();

const AppProviders = composeProviders(
  [QueryClientProvider, { client: queryClient }],
  [HistoryRouter],
  [Provider, { store }],
  [ErrorModalProvider],
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <AppProviders>
    <ToastContainer
      autoClose={2000}
      draggable={false}
      pauseOnHover={true}
      pauseOnFocusLoss={false}
      toastClassName={'toast-container'}
      hideProgressBar={false}
      position={'top-right'}
      closeButton={<span className='material-symbols-outlined'>close</span>}
    />
    <GlobalStyle />
    <App />
    <ReactQueryDevtools initialIsOpen={false} position='bottom-left' />
  </AppProviders>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
